import { withStyles } from '@material-ui/core/styles';

import EditForm from '../maintainer/edit';
import Form from './form';
import service from '../../services/insurance-service';
import { isRequired } from '../../libraries/validators';
import { reduceSpaces } from '../../libraries/utils';
import { editionMaintainer as styles } from '../maintainer/styles';

const Edit = props => {
  const getErrors = values => {
    const errors = {};
    const minimumValues = { code: values.code, name: values.name };
    const newValues = Object.entries(minimumValues).reduce(reduceSpaces, {});
    isRequired(errors, newValues);
    return errors;
  };

  return {
    getErrors,
    service,
    keyName: '_id'
  };
};

export default withStyles(styles)(EditForm(Edit)(Form));
